/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/

import React from "react";
import styles from "./Filter.module.css";
import WorkOrderUserCheckBoxCard from "./WorkOrderUserCheckBoxCard";
import InfoWindowCheckBoxCard from "./InfoWindowCheckBoxCard";
import UserJobFilter from "./UserJobFilter";
import UserFilter from "./UserFilter";
import cx from "classnames";

// Filter wrappers, all filters are imported here
const FilterWrapper = () => {
  return (
    <div>
      <div className={cx(styles.FilterCont, styles.MT12)}>
        <WorkOrderUserCheckBoxCard />
        <InfoWindowCheckBoxCard />
      </div>
      <UserJobFilter />
      <UserFilter />
    </div>
  );
};

export default FilterWrapper;
